export const LANGUAGES = [
  { code: "es", label: "ES", name: "Español" },
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
];

export const translations = {
  es: {
    nav: {
      home: "Inicio",
      menu: "Nuestra Carta",
      craft: "El Arte del Corte",
      tienda: "Tienda",
      reviews: "Reseñas",
      contact: "Contacto",
    },
    header: {
      cta: "Reserva o pide: 671 71 23 35",
      reserve: "Reservar mesa",
    },
    hero: {
      eyebrow: "Guillena · Desde 2015",
      h1Pre: "10 Años Ofreciendo",
      h1Highlight: "Calidad Superior",
      h1Post: ", Exactamente al Corte.",
      subtitle:
        "Desde nuestro espectacular jamón cortado por profesionales hasta los pescados más frescos del día. Una experiencia gastronómica de 10 en un ambiente totalmente familiar en el corazón de Guillena.",
      ctaPrimary: "Ver carta y especialidades",
      ctaSecondary: "Cómo llegar",
      badgeRating: "4.7/5 en Google",
      badgeRatingSub: "Basado en +120 opiniones",
      badgeCraft: "Especialistas en corte tradicional",
      badgeCraftSub: "Producto fresco a diario",
      badgeFamily: "Ambiente familiar",
      badgeFamilySub: "Acogedor para todos",
    },
    esencia: {
      eyebrow: "Nuestra esencia",
      title: "¿Por qué GR a Cuchillo es tu mejor elección en Guillena?",
      items: [
        {
          title: "El Arte del Buen Corte",
          body:
            "Nuestro dueño es un cortador profesional de jamón. La calidad y el respeto por el producto se notan en cada loncha y en cada plato de carne.",
        },
        {
          title: "Del Mar a tu Mesa",
          body:
            "Pijotas, atún fresco o nuestro espectacular bacalao al ajillo. Trabajamos solo con productos de primerísima calidad.",
        },
        {
          title: "Un Trato de 10/10",
          body:
            "Ambiente familiar donde te sentirás en casa. Nuestro equipo, con profesionales como Elena o Aroa, te brindará una atención inmejorable.",
        },
      ],
    },
    platos: {
      eyebrow: "Platos estrella",
      title: "Lo que no puedes dejar de probar",
      subtitle:
        "Una pequeña muestra de nuestra carta, donde cantidad, calidad y precio justo van de la mano. Precio medio 20–30€.",
      items: [
        { name: "Gamba roja a la plancha", tag: "Especialidad de la casa" },
        { name: "Atún rojo de almadraba", tag: "Pieza única" },
        { name: "Gambas cocidas de Huelva", tag: "Sabor del sur" },
        { name: "Bacalao al ajillo", tag: "Clásico" },
        { name: "Almejas de Carril en salsa", tag: "Frescura del mar" },
        { name: "Carrillada en salsa", tag: "De la abuela" },
      ],
    },
    reviews: {
      eyebrow: "Lo dicen ellos",
      title: "Nuestros clientes lo cuentan mejor que nosotros.",
      items: [
        {
          text:
            "El mejor sitio donde he podido comer y el trato fenomenal, les doy un 10/10. Pasaros a probar sus comidas y postres, os juro que os vais a enamorar.",
          author: "Irene Vázquez",
        },
        {
          text:
            "La comida de calidad tanto carne como pescado. El dueño todo un cortador profesional de jamón. Volveremos a repetir seguro. 100% recomendable.",
          author: "Laura Caro",
        },
        {
          text:
            "Trato inmejorable y ambiente totalmente familiar. Hemos comido un bacalao al ajillo espectacular.",
          author: "Elena Hidalgo",
        },
        {
          text:
            "Pedimos pijotas y atún y se nota que es fresco y de muy buena calidad. Buena cantidad, buen trato y buenos precios.",
          author: "Cliente Google",
        },
      ],
    },
    services: {
      eyebrow: "Cómo prefieras",
      title: "Disfruta de GR a Cuchillo a tu manera",
      items: [
        {
          title: "Comer allí",
          body: "Reserva tu mesa y disfruta de nuestro ambiente.",
          cta: "Reservar mesa",
        },
        {
          title: "Para llevar",
          body: "Llama, haz tu pedido y recógelo listo para comer.",
          cta: "Pedir para llevar",
        },
        {
          title: "A domicilio",
          body: "Te llevamos la mejor calidad a la puerta de tu casa.",
          cta: "Pedir a domicilio",
        },
      ],
    },
    reservation: {
      eyebrow: "Reserva tu experiencia",
      title: "¿Te preparamos la mesa?",
      subtitle:
        "Déjanos tus datos y confirmaremos tu reserva por teléfono. Para urgencias, llámanos directamente al 671 71 23 35.",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Email (opcional)",
      date: "Fecha",
      time: "Hora",
      guests: "Comensales",
      serviceType: "Tipo de servicio",
      dineIn: "Comer allí",
      takeaway: "Para llevar",
      delivery: "A domicilio",
      notes: "Notas o alergias (opcional)",
      submit: "Solicitar reserva",
      submitting: "Enviando…",
      success: "¡Reserva solicitada! Te contactaremos pronto.",
      error: "No pudimos enviar tu reserva. Llámanos al 671 71 23 35.",
    },
    footer: {
      title: "¿Te preparamos la mesa?",
      address: "C. Cruz de la Mujer, 2b, 41210 Guillena, Sevilla",
      phoneLabel: "Teléfono y reservas",
      scheduleLabel: "Horario",
      schedule: "Abierto hasta las 18:00h · Ideal para comidas",
      cta: "Llamar al 671 71 23 35",
      rights: "Todos los derechos reservados.",
      built: "GR a Cuchillo · Guillena, Sevilla",
    },
    common: {
      language: "Idioma",
      callNow: "Llamar ahora",
    },
    whatsapp: {
      reservationIntro: "Hola, me gustaría reservar mesa en GR a Cuchillo.",
      serviceIntro: "Hola, quiero hacer un pedido",
      fieldName: "Nombre",
      fieldGuests: "Personas",
      fieldDate: "Fecha y hora",
      fieldNotes: "Notas",
      fieldOrder: "Pedido",
      fieldTime: "Hora deseada",
      fieldAddress: "Dirección (si es a domicilio)",
      thanks: "¡Gracias!",
      buttonLabel: "Reservar por WhatsApp",
      buttonShort: "WhatsApp",
    },
    tienda: {
      eyebrow: "Tienda online",
      title: "Llévate GR a Cuchillo a casa",
      subtitle:
        "Ibéricos cortados a cuchillo, platos al vacío listos para calentar y conservas selectas. Envío en frío a toda España.",
      addToCart: "Añadir al carrito",
      added: "Añadido al carrito",
      navLabel: "Tienda",
      categories: {
        all: "Todo",
        ibericos: "Ibéricos",
        tablas: "Tablas",
        platos: "Platos al vacío",
        pescados: "Pescados",
        bodega: "Bodega",
      },
    },
    cart: {
      title: "Tu carrito",
      empty: "Tu carrito está vacío.",
      emptyCta: "Ver productos",
      subtotal: "Subtotal",
      shipping: "Envío",
      shippingFree: "GRATIS",
      shippingNote: "Gastos de envío y plazo se calculan en el siguiente paso.",
      freeShippingAt: (amount) => `Te faltan ${amount} para el envío GRATIS`,
      freeShippingUnlocked: "¡Has desbloqueado el envío GRATIS!",
      checkout: "Tramitar pedido",
      continueShopping: "Seguir comprando",
      unit: "Unidad",
      remove: "Quitar",
      itemCount: (n) => (n === 1 ? "1 producto" : `${n} productos`),
    },
    checkout: {
      title: "Finalizar pedido",
      subtitle: "Completa tus datos. Pago seguro con tarjeta vía Redsys.",
      contactSection: "Datos de contacto",
      shippingSection: "Dirección de envío",
      name: "Nombre y apellidos",
      email: "Email",
      phone: "Teléfono",
      address: "Dirección completa, código postal y ciudad",
      notes: "Notas para el pedido (opcional)",
      summary: "Resumen del pedido",
      total: "Total",
      pay: "Pagar con tarjeta",
      paying: "Redirigiendo a la pasarela…",
      back: "Volver al carrito",
      empty: "No hay productos en tu carrito.",
      error: "No pudimos crear el pedido. Inténtalo de nuevo.",
      legal:
        "Al pulsar Pagar, serás redirigido a la pasarela segura de Redsys. Tus datos de tarjeta no son almacenados por GR a Cuchillo.",
    },
    payment: {
      successTitle: "¡Pago completado!",
      successBody: "Gracias por tu pedido. Te enviaremos un email con la confirmación.",
      failureTitle: "El pago no se ha completado",
      failureBody: "Tu tarjeta no ha sido cobrada. Puedes intentarlo de nuevo o contactarnos por WhatsApp.",
      pendingTitle: "Procesando pago…",
      pendingBody: "Estamos confirmando el estado del pago. Esto puede tardar unos segundos.",
      orderRef: "Referencia",
      status: "Estado",
      backHome: "Volver al inicio",
      retry: "Reintentar pago",
      contactWa: "Hablar por WhatsApp",
      statusLabels: {
        pending: "Pendiente",
        paid: "Pagado",
        failed: "Fallido",
      },
    },
    carta: {
      eyebrow: "La Carta",
      title: "Cada plato, cuidado al detalle.",
      subtitle:
        "Producto fresco del día, cortes ibéricos de bellota y pescados de almadraba. Precios por media o ración entera.",
      label: "Sección",
      dish: "Plato",
      half: "Media",
      full: "Entera",
      disclaimer:
        "S/M: según mercado. Los precios pueden variar por temporada. IVA incluido.",
      categories: {
        ibericos: "Ibéricos",
        picar: "Para picar",
        sugerencias: "Sugerencias de la casa",
        arroces: "Arroces",
        carnes: "Para los amantes de la carne",
        pescados: "Pescados",
      },
    },
  },

  en: {
    nav: {
      home: "Home",
      menu: "Our Menu",
      craft: "The Art of Carving",
      tienda: "Store",
      reviews: "Reviews",
      contact: "Contact",
    },
    header: {
      cta: "Book or order: +34 671 71 23 35",
      reserve: "Book a table",
    },
    hero: {
      eyebrow: "Guillena · Since 2015",
      h1Pre: "10 Years Serving",
      h1Highlight: "Superior Quality",
      h1Post: ", Cut to Perfection.",
      subtitle:
        "From spectacular hand-carved Iberian ham to the freshest fish of the day. A 10/10 gastronomic experience in a warm, family atmosphere in the heart of Guillena.",
      ctaPrimary: "See the menu",
      ctaSecondary: "How to find us",
      badgeRating: "4.7/5 on Google",
      badgeRatingSub: "Based on 120+ reviews",
      badgeCraft: "Traditional carving specialists",
      badgeCraftSub: "Fresh product daily",
      badgeFamily: "Family atmosphere",
      badgeFamilySub: "Welcoming for everyone",
    },
    esencia: {
      eyebrow: "Our essence",
      title: "Why GR a Cuchillo is your best choice in Guillena",
      items: [
        {
          title: "The Art of the Cut",
          body:
            "Our owner is a professional ham carver. Quality and respect for the product show in every slice and every plate.",
        },
        {
          title: "From Sea to Table",
          body:
            "Hake, fresh tuna, or our spectacular cod with garlic. We only work with top-quality products.",
        },
        {
          title: "A 10/10 Welcome",
          body:
            "A family setting where you'll feel at home. Our team, with professionals like Elena and Aroa, takes care of you.",
        },
      ],
    },
    platos: {
      eyebrow: "Signature dishes",
      title: "What you cannot miss",
      subtitle:
        "A small taste of our menu — generous portions, real quality, fair prices. Average ticket €20–30.",
      items: [
        { name: "Red prawn à la plancha", tag: "House specialty" },
        { name: "Bluefin tuna (almadraba)", tag: "One of a kind" },
        { name: "Boiled prawns from Huelva", tag: "Southern flavour" },
        { name: "Cod with garlic", tag: "Classic" },
        { name: "Carril clams in sauce", tag: "Fresh from the sea" },
        { name: "Braised pork cheeks", tag: "Grandma's recipe" },
      ],
    },
    reviews: {
      eyebrow: "They say it best",
      title: "Our guests tell it better than we ever could.",
      items: [
        {
          text:
            "The best place I've ever eaten and phenomenal service — a clear 10/10. Come and try their food and desserts, you'll fall in love.",
          author: "Irene Vázquez",
        },
        {
          text:
            "Quality food, both meat and fish. The owner is a professional ham carver. We'll definitely be back. 100% recommended.",
          author: "Laura Caro",
        },
        {
          text:
            "Unbeatable service and a truly family atmosphere. We had a spectacular cod with garlic.",
          author: "Elena Hidalgo",
        },
        {
          text:
            "We ordered hake and tuna — you can tell it's fresh and high quality. Generous portions, great service, fair prices.",
          author: "Google guest",
        },
      ],
    },
    services: {
      eyebrow: "However you like",
      title: "Enjoy GR a Cuchillo your way",
      items: [
        {
          title: "Dine in",
          body: "Book your table and enjoy our atmosphere.",
          cta: "Book a table",
        },
        {
          title: "Takeaway",
          body: "Call, order, and pick it up ready to eat.",
          cta: "Order takeaway",
        },
        {
          title: "Delivery",
          body: "We bring the best quality to your door.",
          cta: "Order delivery",
        },
      ],
    },
    reservation: {
      eyebrow: "Reserve your experience",
      title: "Shall we set the table for you?",
      subtitle:
        "Leave us your details and we'll confirm your booking by phone. For urgent requests call +34 671 71 23 35.",
      name: "Full name",
      phone: "Phone",
      email: "Email (optional)",
      date: "Date",
      time: "Time",
      guests: "Guests",
      serviceType: "Service",
      dineIn: "Dine in",
      takeaway: "Takeaway",
      delivery: "Delivery",
      notes: "Notes or allergies (optional)",
      submit: "Request reservation",
      submitting: "Sending…",
      success: "Reservation requested! We'll contact you soon.",
      error: "We couldn't send your reservation. Please call +34 671 71 23 35.",
    },
    footer: {
      title: "Shall we set the table?",
      address: "C. Cruz de la Mujer, 2b, 41210 Guillena, Sevilla",
      phoneLabel: "Phone & bookings",
      scheduleLabel: "Hours",
      schedule: "Open until 18:00 · Lunch service",
      cta: "Call +34 671 71 23 35",
      rights: "All rights reserved.",
      built: "GR a Cuchillo · Guillena, Sevilla",
    },
    common: {
      language: "Language",
      callNow: "Call now",
    },
    whatsapp: {
      reservationIntro: "Hi, I'd like to book a table at GR a Cuchillo.",
      serviceIntro: "Hi, I'd like to place an order",
      fieldName: "Name",
      fieldGuests: "Guests",
      fieldDate: "Date & time",
      fieldNotes: "Notes",
      fieldOrder: "Order",
      fieldTime: "Preferred time",
      fieldAddress: "Address (for delivery)",
      thanks: "Thanks!",
      buttonLabel: "Book via WhatsApp",
      buttonShort: "WhatsApp",
    },
    tienda: {
      eyebrow: "Online store",
      title: "Take GR a Cuchillo home",
      subtitle:
        "Hand-carved Iberian cuts, vacuum-packed dishes ready to heat and selected preserves. Refrigerated shipping across Spain.",
      addToCart: "Add to cart",
      added: "Added to cart",
      navLabel: "Store",
      categories: {
        all: "All",
        ibericos: "Iberian cuts",
        tablas: "Sharing boards",
        platos: "Vacuum-packed",
        pescados: "Fish & preserves",
        bodega: "Cellar",
      },
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      emptyCta: "Browse products",
      subtotal: "Subtotal",
      shipping: "Shipping",
      shippingFree: "FREE",
      shippingNote: "Shipping costs and delivery time are shown next.",
      freeShippingAt: (amount) => `Add ${amount} more for FREE shipping`,
      freeShippingUnlocked: "You've unlocked FREE shipping!",
      checkout: "Checkout",
      continueShopping: "Continue shopping",
      unit: "Unit",
      remove: "Remove",
      itemCount: (n) => (n === 1 ? "1 item" : `${n} items`),
    },
    checkout: {
      title: "Complete your order",
      subtitle: "Fill in your details. Secure card payment via Redsys.",
      contactSection: "Contact details",
      shippingSection: "Shipping address",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Full address, postcode and city",
      notes: "Order notes (optional)",
      summary: "Order summary",
      total: "Total",
      pay: "Pay by card",
      paying: "Redirecting to the gateway…",
      back: "Back to cart",
      empty: "No items in your cart.",
      error: "We couldn't create your order. Please try again.",
      legal:
        "When you click Pay you'll be redirected to the secure Redsys gateway. GR a Cuchillo never stores your card details.",
    },
    payment: {
      successTitle: "Payment completed!",
      successBody: "Thank you for your order. We'll send a confirmation by email.",
      failureTitle: "Payment was not completed",
      failureBody: "Your card was not charged. You can retry or contact us on WhatsApp.",
      pendingTitle: "Processing payment…",
      pendingBody: "We're confirming the status of your payment. This may take a few seconds.",
      orderRef: "Reference",
      status: "Status",
      backHome: "Back to home",
      retry: "Retry payment",
      contactWa: "Chat on WhatsApp",
      statusLabels: {
        pending: "Pending",
        paid: "Paid",
        failed: "Failed",
      },
    },
    carta: {
      eyebrow: "The Menu",
      title: "Every dish, crafted with care.",
      subtitle:
        "Daily-fresh produce, acorn-fed Iberian cuts and almadraba bluefin tuna. Prices per half or full portion.",
      label: "Section",
      dish: "Dish",
      half: "Half",
      full: "Full",
      disclaimer:
        "S/M: market price. Prices may vary seasonally. VAT included.",
      categories: {
        ibericos: "Iberian cuts",
        picar: "Sharing",
        sugerencias: "House specials",
        arroces: "Rice dishes",
        carnes: "Meat lovers",
        pescados: "Fish & seafood",
      },
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      menu: "Notre Carte",
      craft: "L'Art de la Découpe",
      tienda: "Boutique",
      reviews: "Avis",
      contact: "Contact",
    },
    header: {
      cta: "Réservez ou commandez : +34 671 71 23 35",
      reserve: "Réserver",
    },
    hero: {
      eyebrow: "Guillena · Depuis 2015",
      h1Pre: "10 ans à offrir une",
      h1Highlight: "qualité supérieure",
      h1Post: ", taillée à la perfection.",
      subtitle:
        "Du spectaculaire jambon découpé à la main aux poissons les plus frais du jour. Une expérience gastronomique 10/10 dans une ambiance familiale au cœur de Guillena.",
      ctaPrimary: "Voir la carte",
      ctaSecondary: "Comment venir",
      badgeRating: "4,7/5 sur Google",
      badgeRatingSub: "Plus de 120 avis",
      badgeCraft: "Spécialistes de la découpe traditionnelle",
      badgeCraftSub: "Produit frais quotidien",
      badgeFamily: "Ambiance familiale",
      badgeFamilySub: "Chaleureuse pour tous",
    },
    esencia: {
      eyebrow: "Notre essence",
      title: "Pourquoi GR a Cuchillo est votre meilleur choix à Guillena",
      items: [
        {
          title: "L'art de la découpe",
          body:
            "Notre patron est un coupeur de jambon professionnel. La qualité et le respect du produit se ressentent à chaque tranche.",
        },
        {
          title: "De la mer à la table",
          body:
            "Merlu, thon frais ou notre spectaculaire morue à l'ail. Uniquement des produits de toute première qualité.",
        },
        {
          title: "Un accueil 10/10",
          body:
            "Une atmosphère familiale où l'on se sent chez soi. Notre équipe, avec Elena et Aroa, prend soin de vous.",
        },
      ],
    },
    platos: {
      eyebrow: "Plats signatures",
      title: "À ne pas manquer",
      subtitle:
        "Un avant-goût de notre carte — généreux, de qualité, à prix juste. Ticket moyen 20–30 €.",
      items: [
        { name: "Gambas rouges à la plancha", tag: "Spécialité maison" },
        { name: "Thon rouge d'almadraba", tag: "Pièce unique" },
        { name: "Gambas de Huelva cuites", tag: "Saveur du sud" },
        { name: "Morue à l'ail", tag: "Classique" },
        { name: "Palourdes de Carril en sauce", tag: "Fraîcheur marine" },
        { name: "Joue de porc braisée", tag: "Recette d'autrefois" },
      ],
    },
    reviews: {
      eyebrow: "Ils en parlent mieux",
      title: "Nos clients le racontent mieux que nous.",
      items: [
        {
          text:
            "Le meilleur endroit où j'ai pu manger, accueil phénoménal — 10/10. Venez goûter, vous allez adorer.",
          author: "Irene Vázquez",
        },
        {
          text:
            "Cuisine de qualité, viande et poisson. Le patron est un vrai coupeur de jambon. On reviendra. 100% recommandé.",
          author: "Laura Caro",
        },
        {
          text:
            "Accueil imbattable, ambiance familiale. Nous avons mangé une morue à l'ail spectaculaire.",
          author: "Elena Hidalgo",
        },
        {
          text:
            "Merlu et thon — frais et de très bonne qualité. Bonne quantité, bel accueil, bons prix.",
          author: "Client Google",
        },
      ],
    },
    services: {
      eyebrow: "Comme vous préférez",
      title: "Profitez de GR a Cuchillo à votre façon",
      items: [
        {
          title: "Sur place",
          body: "Réservez votre table et profitez de l'ambiance.",
          cta: "Réserver",
        },
        {
          title: "À emporter",
          body: "Appelez, commandez et récupérez votre repas prêt.",
          cta: "Commander à emporter",
        },
        {
          title: "À domicile",
          body: "On vous livre la meilleure qualité à votre porte.",
          cta: "Commander à domicile",
        },
      ],
    },
    reservation: {
      eyebrow: "Réservez votre expérience",
      title: "On vous prépare la table ?",
      subtitle:
        "Laissez-nous vos coordonnées, nous confirmerons par téléphone. Urgence : +34 671 71 23 35.",
      name: "Nom complet",
      phone: "Téléphone",
      email: "Email (optionnel)",
      date: "Date",
      time: "Heure",
      guests: "Convives",
      serviceType: "Service",
      dineIn: "Sur place",
      takeaway: "À emporter",
      delivery: "Livraison",
      notes: "Notes ou allergies (optionnel)",
      submit: "Demander la réservation",
      submitting: "Envoi…",
      success: "Réservation demandée ! Nous vous contactons bientôt.",
      error: "Envoi impossible. Appelez le +34 671 71 23 35.",
    },
    footer: {
      title: "On vous prépare la table ?",
      address: "C. Cruz de la Mujer, 2b, 41210 Guillena, Sevilla",
      phoneLabel: "Téléphone & réservations",
      scheduleLabel: "Horaires",
      schedule: "Ouvert jusqu'à 18h00 · Service déjeuner",
      cta: "Appeler le +34 671 71 23 35",
      rights: "Tous droits réservés.",
      built: "GR a Cuchillo · Guillena, Séville",
    },
    common: {
      language: "Langue",
      callNow: "Appeler",
    },
    whatsapp: {
      reservationIntro: "Bonjour, je souhaite réserver une table à GR a Cuchillo.",
      serviceIntro: "Bonjour, je souhaite passer une commande",
      fieldName: "Nom",
      fieldGuests: "Convives",
      fieldDate: "Date & heure",
      fieldNotes: "Notes",
      fieldOrder: "Commande",
      fieldTime: "Heure souhaitée",
      fieldAddress: "Adresse (pour livraison)",
      thanks: "Merci !",
      buttonLabel: "Réserver via WhatsApp",
      buttonShort: "WhatsApp",
    },
    tienda: {
      eyebrow: "Boutique en ligne",
      title: "Emportez GR a Cuchillo chez vous",
      subtitle:
        "Ibériques coupés au couteau, plats sous vide prêts à chauffer et conserves sélectionnées. Livraison réfrigérée en Espagne.",
      addToCart: "Ajouter au panier",
      added: "Ajouté au panier",
      navLabel: "Boutique",
      categories: {
        all: "Tout",
        ibericos: "Ibériques",
        tablas: "Planches",
        platos: "Sous vide",
        pescados: "Poissons & conserves",
        bodega: "Cave",
      },
    },
    cart: {
      title: "Votre panier",
      empty: "Votre panier est vide.",
      emptyCta: "Voir les produits",
      subtotal: "Sous-total",
      shipping: "Livraison",
      shippingFree: "OFFERTE",
      shippingNote: "Les frais de port s'affichent à l'étape suivante.",
      freeShippingAt: (amount) => `Encore ${amount} pour la livraison OFFERTE`,
      freeShippingUnlocked: "Vous avez débloqué la livraison OFFERTE !",
      checkout: "Finaliser la commande",
      continueShopping: "Continuer les achats",
      unit: "Unité",
      remove: "Retirer",
      itemCount: (n) => (n === 1 ? "1 produit" : `${n} produits`),
    },
    checkout: {
      title: "Finaliser votre commande",
      subtitle: "Remplissez vos informations. Paiement sécurisé par carte via Redsys.",
      contactSection: "Coordonnées",
      shippingSection: "Adresse de livraison",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse complète, code postal et ville",
      notes: "Notes pour la commande (optionnel)",
      summary: "Résumé de la commande",
      total: "Total",
      pay: "Payer par carte",
      paying: "Redirection vers la passerelle…",
      back: "Retour au panier",
      empty: "Aucun article dans votre panier.",
      error: "Impossible de créer la commande. Veuillez réessayer.",
      legal:
        "En cliquant sur Payer, vous serez redirigé vers la passerelle sécurisée Redsys. Vos données de carte ne sont pas stockées par GR a Cuchillo.",
    },
    payment: {
      successTitle: "Paiement effectué !",
      successBody: "Merci pour votre commande. Vous recevrez une confirmation par email.",
      failureTitle: "Le paiement n'a pas abouti",
      failureBody: "Votre carte n'a pas été débitée. Vous pouvez réessayer ou nous contacter sur WhatsApp.",
      pendingTitle: "Traitement du paiement…",
      pendingBody: "Nous confirmons le statut du paiement. Cela peut prendre quelques secondes.",
      orderRef: "Référence",
      status: "Statut",
      backHome: "Retour à l'accueil",
      retry: "Réessayer le paiement",
      contactWa: "Parler sur WhatsApp",
      statusLabels: {
        pending: "En attente",
        paid: "Payé",
        failed: "Échec",
      },
    },
    carta: {
      eyebrow: "La Carte",
      title: "Chaque plat, soigné dans le détail.",
      subtitle:
        "Produit frais du jour, ibériques de bellota et thon rouge d'almadraba. Prix par demi-portion ou portion entière.",
      label: "Section",
      dish: "Plat",
      half: "Demi",
      full: "Entière",
      disclaimer:
        "S/M : prix du marché. Les prix peuvent varier selon la saison. TVA incluse.",
      categories: {
        ibericos: "Ibériques",
        picar: "À partager",
        sugerencias: "Suggestions de la maison",
        arroces: "Riz",
        carnes: "Pour les amateurs de viande",
        pescados: "Poissons & fruits de mer",
      },
    },
  },

  de: {
    nav: {
      home: "Start",
      menu: "Karte",
      craft: "Kunst des Schnitts",
      tienda: "Shop",
      reviews: "Bewertungen",
      contact: "Kontakt",
    },
    header: {
      cta: "Reservieren / bestellen: +34 671 71 23 35",
      reserve: "Tisch reservieren",
    },
    hero: {
      eyebrow: "Guillena · Seit 2015",
      h1Pre: "10 Jahre",
      h1Highlight: "Spitzenqualität",
      h1Post: ", exakt geschnitten.",
      subtitle:
        "Vom spektakulären, von Hand geschnittenen Schinken bis zu den frischesten Fischen des Tages. Ein 10/10 Genuss in familiärer Atmosphäre im Herzen von Guillena.",
      ctaPrimary: "Karte ansehen",
      ctaSecondary: "Anfahrt",
      badgeRating: "4,7/5 bei Google",
      badgeRatingSub: "Über 120 Bewertungen",
      badgeCraft: "Spezialisten für traditionelles Schneiden",
      badgeCraftSub: "Täglich frisch",
      badgeFamily: "Familiäre Atmosphäre",
      badgeFamilySub: "Für alle einladend",
    },
    esencia: {
      eyebrow: "Unsere Essenz",
      title: "Warum GR a Cuchillo Ihre beste Wahl in Guillena ist",
      items: [
        {
          title: "Die Kunst des Schnitts",
          body:
            "Unser Inhaber ist professioneller Schinkenschneider. Qualität und Respekt vor dem Produkt zeigen sich in jeder Scheibe.",
        },
        {
          title: "Vom Meer auf den Tisch",
          body:
            "Seehecht, frischer Thunfisch oder unser spektakulärer Knoblauch-Kabeljau. Nur Produkte erster Güte.",
        },
        {
          title: "Service 10/10",
          body:
            "Ein familiäres Ambiente, in dem Sie sich zuhause fühlen. Unser Team, mit Elena und Aroa, kümmert sich um Sie.",
        },
      ],
    },
    platos: {
      eyebrow: "Signature-Gerichte",
      title: "Was Sie probieren müssen",
      subtitle:
        "Ein Auszug aus unserer Karte — großzügig, qualitativ, fair bepreist. Durchschnitt 20–30 €.",
      items: [
        { name: "Rote Garnelen von der Plancha", tag: "Haus-Spezialität" },
        { name: "Roter Thunfisch (Almadraba)", tag: "Einzigartig" },
        { name: "Gekochte Garnelen aus Huelva", tag: "Geschmack des Südens" },
        { name: "Kabeljau mit Knoblauch", tag: "Klassiker" },
        { name: "Carril-Muscheln in Sauce", tag: "Frisch aus dem Meer" },
        { name: "Geschmorte Schweinebäckchen", tag: "Großmutters Rezept" },
      ],
    },
    reviews: {
      eyebrow: "Stimmen unserer Gäste",
      title: "Unsere Gäste erzählen es besser als wir.",
      items: [
        {
          text:
            "Der beste Ort, an dem ich gegessen habe — phänomenaler Service, klare 10/10. Probieren Sie es, Sie werden es lieben.",
          author: "Irene Vázquez",
        },
        {
          text:
            "Qualität bei Fleisch und Fisch. Der Inhaber ist ein wahrer Schinkenmeister. Wir kommen wieder. Absolut empfehlenswert.",
          author: "Laura Caro",
        },
        {
          text:
            "Unschlagbarer Service, familiäre Atmosphäre. Wir hatten einen spektakulären Knoblauch-Kabeljau.",
          author: "Elena Hidalgo",
        },
        {
          text:
            "Seehecht und Thunfisch — frisch und sehr gut. Großzügige Portionen, freundlicher Service, faire Preise.",
          author: "Google-Gast",
        },
      ],
    },
    services: {
      eyebrow: "Ganz wie Sie wünschen",
      title: "Genießen Sie GR a Cuchillo nach Ihrer Art",
      items: [
        {
          title: "Vor Ort",
          body: "Reservieren Sie Ihren Tisch und genießen Sie das Ambiente.",
          cta: "Tisch reservieren",
        },
        {
          title: "Zum Mitnehmen",
          body: "Anrufen, bestellen, abholen — fertig.",
          cta: "Mitnahme bestellen",
        },
        {
          title: "Lieferung",
          body: "Wir bringen Top-Qualität direkt zu Ihnen.",
          cta: "Lieferung bestellen",
        },
      ],
    },
    reservation: {
      eyebrow: "Reservieren Sie Ihr Erlebnis",
      title: "Sollen wir den Tisch decken?",
      subtitle:
        "Hinterlassen Sie Ihre Daten — wir bestätigen telefonisch. Dringend? +34 671 71 23 35.",
      name: "Vollständiger Name",
      phone: "Telefon",
      email: "E-Mail (optional)",
      date: "Datum",
      time: "Uhrzeit",
      guests: "Gäste",
      serviceType: "Service",
      dineIn: "Vor Ort",
      takeaway: "Mitnahme",
      delivery: "Lieferung",
      notes: "Anmerkungen / Allergien (optional)",
      submit: "Reservierung anfragen",
      submitting: "Senden…",
      success: "Anfrage gesendet! Wir melden uns in Kürze.",
      error: "Senden fehlgeschlagen. Bitte +34 671 71 23 35 anrufen.",
    },
    footer: {
      title: "Sollen wir den Tisch decken?",
      address: "C. Cruz de la Mujer, 2b, 41210 Guillena, Sevilla",
      phoneLabel: "Telefon & Reservierungen",
      scheduleLabel: "Öffnungszeiten",
      schedule: "Geöffnet bis 18:00 Uhr · Mittagsservice",
      cta: "+34 671 71 23 35 anrufen",
      rights: "Alle Rechte vorbehalten.",
      built: "GR a Cuchillo · Guillena, Sevilla",
    },
    common: {
      language: "Sprache",
      callNow: "Anrufen",
    },
    whatsapp: {
      reservationIntro: "Hallo, ich möchte einen Tisch bei GR a Cuchillo reservieren.",
      serviceIntro: "Hallo, ich möchte eine Bestellung aufgeben",
      fieldName: "Name",
      fieldGuests: "Gäste",
      fieldDate: "Datum & Uhrzeit",
      fieldNotes: "Anmerkungen",
      fieldOrder: "Bestellung",
      fieldTime: "Gewünschte Uhrzeit",
      fieldAddress: "Adresse (für Lieferung)",
      thanks: "Danke!",
      buttonLabel: "Über WhatsApp reservieren",
      buttonShort: "WhatsApp",
    },
    tienda: {
      eyebrow: "Online-Shop",
      title: "Holen Sie sich GR a Cuchillo nach Hause",
      subtitle:
        "Von Hand geschnittene iberische Spezialitäten, vakuumierte fertige Gerichte und ausgewählte Konserven. Gekühlter Versand in ganz Spanien.",
      addToCart: "In den Warenkorb",
      added: "Hinzugefügt",
      navLabel: "Shop",
      categories: {
        all: "Alle",
        ibericos: "Iberisches",
        tablas: "Platten",
        platos: "Vakuumiert",
        pescados: "Fisch & Konserven",
        bodega: "Weinkeller",
      },
    },
    cart: {
      title: "Ihr Warenkorb",
      empty: "Ihr Warenkorb ist leer.",
      emptyCta: "Produkte ansehen",
      subtotal: "Zwischensumme",
      shipping: "Versand",
      shippingFree: "KOSTENLOS",
      shippingNote: "Versandkosten und Lieferzeit im nächsten Schritt.",
      freeShippingAt: (amount) => `Noch ${amount} bis zum KOSTENLOSEN Versand`,
      freeShippingUnlocked: "Sie haben KOSTENLOSEN Versand freigeschaltet!",
      checkout: "Zur Kasse",
      continueShopping: "Weiter einkaufen",
      unit: "Einheit",
      remove: "Entfernen",
      itemCount: (n) => (n === 1 ? "1 Produkt" : `${n} Produkte`),
    },
    checkout: {
      title: "Bestellung abschließen",
      subtitle: "Geben Sie Ihre Daten ein. Sichere Kartenzahlung über Redsys.",
      contactSection: "Kontaktdaten",
      shippingSection: "Lieferadresse",
      name: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon",
      address: "Vollständige Adresse, PLZ und Stadt",
      notes: "Bestellnotizen (optional)",
      summary: "Bestellübersicht",
      total: "Gesamt",
      pay: "Mit Karte zahlen",
      paying: "Weiterleitung zur Zahlungs-Gateway…",
      back: "Zurück zum Warenkorb",
      empty: "Keine Produkte im Warenkorb.",
      error: "Bestellung konnte nicht erstellt werden. Bitte erneut versuchen.",
      legal:
        "Mit Klick auf Zahlen werden Sie zur sicheren Redsys-Gateway weitergeleitet. Ihre Kartendaten werden nicht von GR a Cuchillo gespeichert.",
    },
    payment: {
      successTitle: "Zahlung erfolgreich!",
      successBody: "Vielen Dank für Ihre Bestellung. Sie erhalten eine Bestätigung per E-Mail.",
      failureTitle: "Zahlung nicht abgeschlossen",
      failureBody: "Ihre Karte wurde nicht belastet. Sie können es erneut versuchen oder uns über WhatsApp kontaktieren.",
      pendingTitle: "Zahlung wird verarbeitet…",
      pendingBody: "Wir bestätigen den Zahlungsstatus. Dies kann einige Sekunden dauern.",
      orderRef: "Referenz",
      status: "Status",
      backHome: "Zurück zur Startseite",
      retry: "Zahlung wiederholen",
      contactWa: "WhatsApp-Chat",
      statusLabels: {
        pending: "Ausstehend",
        paid: "Bezahlt",
        failed: "Fehlgeschlagen",
      },
    },
    carta: {
      eyebrow: "Die Speisekarte",
      title: "Jedes Gericht, mit Sorgfalt zubereitet.",
      subtitle:
        "Täglich frische Produkte, Eichelmast-Iberico und Almadraba-Thunfisch. Preise für halbe oder ganze Portion.",
      label: "Bereich",
      dish: "Gericht",
      half: "Halb",
      full: "Ganz",
      disclaimer:
        "S/M: Tagespreis. Preise können je nach Saison variieren. MwSt. inkl.",
      categories: {
        ibericos: "Iberische Spezialitäten",
        picar: "Zum Teilen",
        sugerencias: "Empfehlungen des Hauses",
        arroces: "Reisgerichte",
        carnes: "Für Fleischliebhaber",
        pescados: "Fisch & Meeresfrüchte",
      },
    },
  },
};
